import { render, staticRenderFns } from "./GalleryDetail.vue?vue&type=template&id=511f2748&scoped=true&"
import script from "./GalleryDetail.vue?vue&type=script&lang=js&"
export * from "./GalleryDetail.vue?vue&type=script&lang=js&"
import style0 from "./GalleryDetail.vue?vue&type=style&index=0&id=511f2748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f2748",
  null
  
)

export default component.exports